import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Firebase web config. These values are read from environment variables
// (CRA requires the REACT_APP_ prefix to expose them to the browser).
// Firebase web config keys are not secret by design — access is controlled
// by Firestore security rules, not by hiding these values.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// True only when the minimum config needed to talk to Firestore is present.
// The calendar page uses this to show a friendly "not configured yet" message
// instead of crashing when env vars are missing (e.g. before setup).
export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId
);

const app = isFirebaseConfigured ? initializeApp(firebaseConfig) : null;

export const db = app ? getFirestore(app) : null;
